const newProductSlider = (e) => {
	const { dataset } = e;
	const {
		after: productAfterSlug,
		before: productBeforeSlug,
		current: productCurrent,
	} = dataset;
	let loader, productMediaDefer;

	async function getProductDocument(slug) {
		const res = await fetch(`/${slug}`, { cache: "force-cache" });
		const doc = await res.json();
		const sectionId = document
			.querySelector(".main-product")
			.getAttribute("id")
			.replace("MainProduct-", "");
		return doc[`${sectionId}`];
	}

	function reinitializeTagshopWidget() {
		const tagshopContainer = document.querySelector(".tagshop-mobile");

		if (tagshopContainer) {
			const newContainer = document.createElement("div");
			newContainer.className = "tagshop";
			newContainer.style.cssText = "width:100%;height:100%;overflow: auto;";

			const socialWallDiv = document.createElement("div");
			socialWallDiv.className = "tagshop-socialwall";
			socialWallDiv.setAttribute("data-wall-id", "4988");
			socialWallDiv.setAttribute("data-source", "website");

			const newScript = document.createElement("script");
			newScript.src = "https://widget.tagshop.ai/embed-lite.min.js";
			newScript.type = "text/javascript";

			newContainer.appendChild(socialWallDiv);
			newContainer.appendChild(newScript);

			tagshopContainer.parentNode.replaceChild(newContainer, tagshopContainer);
			newScript.onload = () => {
				console.log("Tagshop widget reinitialized");
			};
		} 
	}

	async function addProduct(
		slider,
		slug,
		mode,
		isFirstLoad = false,
		nextSlide = 0,
		prevSlide = 0
	) {
		if (!slug) return;

		const sectionId = document
			.querySelector(".main-product")
			.getAttribute("id")
			.replace("MainProduct-", "");
		slug = `${slug}?sections=${sectionId}`;
		try {
			const productDoc = await getProductDocument(slug);
			const productPackaged = packageProductSection(
				mode,
				isFirstLoad,
				productDoc,
				slug
			);

			const productColors = productPackaged.querySelectorAll(".product__color");

			productMediaDefer = productPackaged.querySelector(
				".product .small-hide img"
			).src;

			if (slider.querySelector(`[data-slug="${slug}"]`)) {
				console.warn("Product already added", slug);
				return;
			}

			if (mode === "append") {
				slider.append(productPackaged);
			}

			window.mainSlider.setup();
			window.clickEventColor(productColors);
			addIngSlider();

			console.log(nextSlide);
			if (nextSlide > 0) {
				const sliderQuery =
					productPackaged.querySelector(".main-product").dataset.before;
				console.log({ sliderQuery, slug });
				if ((sliderQuery == "") | (sliderQuery == null)) {
					loader?.classList.add("hidden");
					enableSlider();
				}
				addProduct(slider, sliderQuery, "append", false, nextSlide - 1);
			} else if (prevSlide > 0) {
				const sliderQuery =
					productPackaged.querySelector(".main-product").dataset.after;
				console.log({ sliderQuery, slug });
				if ((sliderQuery == "") | (sliderQuery == null)) {
					loader?.classList.add("hidden");
					enableSlider();
				}
				addProduct(slider, sliderQuery, "prepend", false, 0, prevSlide - 1);
			} else {
				loader?.classList.add("hidden");
				enableSlider();
			}
			setTimeout(() => {
				adjustVariantAvailabilityOnProductMobileView();
			}, 400);
			return productPackaged;
		} catch (error) {
			console.error("Error adding product:", error);
		}
	}

	function addIngSlider() {
		const sliderActive = window.mainSlider.getPos();
		const productActive = document.querySelector(
			`.swipe-wrap .product-packaged[data-index="${sliderActive}"]`
		);
		const content = productActive?.querySelector(".tagshop-socialwall");

		if (content && !content.classList.contains("is-render")) {
			const mainSliderContent = document.querySelector(
				".main-slider-pdp .tagshop-socialwall"
			);
			if (mainSliderContent) {
				content.innerHTML = mainSliderContent.innerHTML;
				const swiperContainer = content.querySelector("swiper-container");
				if (swiperContainer) {
					swiperContainer.querySelectorAll("swiper-slide").forEach((item) => {
						const wrapper = item.querySelector(".ts_ms_post_wrapper");
						wrapper?.addEventListener("click", () => {
							const id = wrapper.id;
							document.getElementById(id)?.click();
						});
					});
					content.classList.add("is-render");
				}
			}
		}
	}

	function notifySlide() {
		const pos = window.mainSlider?.getPos();
		if (pos === undefined) return;

		const pdp = document.querySelector(`.product-packaged[data-index="0"]`);
		if (!pdp) return;

		const beforeElement = pdp.querySelector("[data-before]");
		if (beforeElement?.dataset.before) {
			const slug = pdp.getAttribute("data-slug");
			const slugCookie = getCookie("sliderSlug");
			if (slug && slug) {
				const noti = pdp.querySelector(".arrow-product-gallery");
				if (noti) {
					noti.style.visibility = "visible";
					// setCookie("sliderSlug", slug, 0.1);
					setTimeout(() => {
						noti.style.visibility = "hidden";
						noti.setAttribute("data-show", "1");
					}, 3000);
				}
			}
		}
	}

	async function initSlider() {

		console.log('init slider');

		const main = document.querySelector("main");
		const originalPackagedProduct = packageProduct(document);
		originalPackagedProduct.dataset.original = true;
		const socialwall = originalPackagedProduct.querySelector(
			".tagshop-socialwall"
		);
		socialwall?.classList.add("ing-main");
		socialwall?.classList.remove("tagshop-socialwall-not-slider");
		const newWrapSlider = document.createElement("div");
		newWrapSlider.classList.add("swipe-wrap");
		newWrapSlider.append(originalPackagedProduct);
		main.prepend(newWrapSlider);
		const originalsColorPicker =
			originalPackagedProduct.querySelectorAll(".product__color");
		loader = originalPackagedProduct.querySelector(".loader-more-products");
		const productMedia = originalPackagedProduct.querySelector(
			".product .small-hide img"
		).src;

		window.mainSlider = new Swipe(main, {
			startSlide: 0,
			draggable: false,
			autoRestart: false,
			continuous: true,
			disableScroll: false,
			stopPropagation: true,
			callback: function (index, element) {},
			transitionEnd: async function (index, element) {
				let url = `${element.dataset.slug}`.split("?")[0];
				if (index > 0) {
					history.pushState({}, null, `/${url}`);
				}

				const productMediaDeferSlider = element.querySelector(
					".product .small-hide img"
				).src;
				const productModal = document.querySelector(
					".product-media-modal .product-media-modal__content"
				).children[0];

				if (!index) {
					productModal.setAttribute("src", productMedia);
					productModal.setAttribute("srcset", productMedia);
				} else {
					productModal.setAttribute("src", productMediaDeferSlider);
					productModal.setAttribute("srcset", productMediaDeferSlider);
				}

				reinitializeTagshopWidget();
				console.log(index);

				if (index === window.mainSlider.getNumSlides() - 1) {
					const nextSlug =
						element.querySelector("[data-before]")?.dataset.before;
					loader = element.querySelector(".loader-more-products");
					if (nextSlug) {
						console.log(loader, index);
						loader?.classList.remove("hidden");
						enableNotScrollSlider();
						await addProduct(newWrapSlider, nextSlug, "append", false, 5);
					}
				}
			},
		});
		// Initial load of 10 products
		let loadTasks = [];
		const currentUrl = window.location.pathname;

		if (window.innerWidth <= 1023) {
			setTimeout(() => {
				if (
					productAfterSlug &&
					productAfterSlug !== productBeforeSlug &&
					productAfterSlug !== productCurrent &&
					productBeforeSlug !== productCurrent &&
					currentUrl !== productAfterSlug
				) {
					loader?.classList.remove("hidden");
					enableNotScrollSlider();
					loadTasks.push(
						addProduct(newWrapSlider, productAfterSlug, "append", false, 5)
					);
				}

				if (
					productBeforeSlug &&
					productAfterSlug !== productBeforeSlug &&
					productAfterSlug !== productCurrent &&
					productBeforeSlug !== productCurrent &&
					currentUrl !== productBeforeSlug
				) {
					loader?.classList.remove("hidden");
					enableNotScrollSlider();
					loadTasks.push(
						addProduct(newWrapSlider, productBeforeSlug, "append", false, 5)
					);
				}
			}, 500);
		}

		if (window.innerWidth >= 1024) {
			enableNotScrollSlider();
		}

		await Promise.allSettled(loadTasks);

		addIngSlider();
		notifySlide();
		window.clickEventColor(originalsColorPicker);

		setTimeout(() => {
			adjustVariantAvailabilityOnProductMobileView();
		}, 400);
	}

	function enableSlider() {
		window.mainSlider?.enable();
	}

	function enableNotScrollSlider() {
		window.mainSlider?.disable();
	}

	function packageProduct(
		doc,
		slug = location.pathname.replace("/products/", "/")
	) {
		const main = doc.querySelector("main");
		if (main.querySelector(".product-packaged")) {
			console.warn("Product already packaged");
		}

		const newPackageProduct = document.createElement("div");
		newPackageProduct.classList.add("product-packaged");
		newPackageProduct.dataset.slug = slug;

		doc.querySelectorAll("main > section").forEach((section) => {
			newPackageProduct.append(section);
		});

		setTimeout(() => {
			const actionsAnchor = newPackageProduct.querySelector(
				"product-form.product-form.modal"
			);
			if (actionsAnchor) {
				const newActionsForm = actionsAnchor.cloneNode(true);
				actionsAnchor.classList.add("mobile-hidden");
				newActionsForm.classList.add("floating");
				newPackageProduct.append(newActionsForm);

				const updatePosition = () => {
					const { top } = actionsAnchor.getBoundingClientRect();
					const topDisplacement =
						Math.min(top, window.innerHeight - 60) +
						document.body.scrollTop -
						100;
					newActionsForm.style.top = `${topDisplacement}px`;
				};
				updatePosition();

				setInterval(updatePosition, 1000 / 60);
			}
		}, 1);

		return newPackageProduct;
	}

	function packageProductSection(
		mode,
		isFirstLoad,
		doc,
		slug = location.pathname.replace("/products/", "")
	) {
		const newPackageProduct = document.createElement("div");
		newPackageProduct.classList.add("product-packaged");
		newPackageProduct.dataset.slug = slug;

		newPackageProduct.insertAdjacentHTML("afterbegin", doc);

		setTimeout(async () => {
			const actionsAnchor = newPackageProduct.querySelector(
				"product-form.product-form.modal"
			);
			if (actionsAnchor) {
				const newActionsForm = actionsAnchor.cloneNode(true);
				actionsAnchor.classList.add("mobile-hidden");
				newActionsForm.classList.add("floating");
				newPackageProduct.append(newActionsForm);

				const updatePosition = () => {
					const { top } = actionsAnchor.getBoundingClientRect();
					const topDisplacement =
						Math.min(top, window.innerHeight - 60) +
						document.body.scrollTop -
						100;
					newActionsForm.style.top = `${topDisplacement}px`;
				};
				updatePosition();

				if (!isFirstLoad) {
					await window.productSliderModules.loadProduct(mode);
				}

				setInterval(updatePosition, 1000 / 60);
			}
		}, 200);

		return newPackageProduct;
	}

	document.addEventListener("DOMContentLoaded", initSlider);
	window.initProductSlider = initSlider;
};

newProductSlider(document.querySelector(".product-slide"));